// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2wJFS","cell":"ColumnAccessor_cell__kE7mD","firstCellAccent":"ColumnAccessor_firstCellAccent__3A5m7"};